import { useLocation, useNavigate } from 'react-router-dom';
import { buildQueryParams, readQueryParams, searchParam } from './epic/searchEpic';


export const useUpdateQueryParam = () => {
  const navigate = useNavigate();
  const location = useLocation()

  const handleUpdateQueryParam = (field: string, value: any) => {
    const currentPath = location.pathname;
        const former = readQueryParams(searchParam, location.search);
        const filters = {
            ...former,
            [field]: value
        }
        const query = buildQueryParams(searchParam, filters);
    navigate(currentPath + query, { replace: true });
  };

  return handleUpdateQueryParam;
};